export const GrantAuthorizationType = {
    GenericAuthorization: 'GenericAuthorization',
    ContractExecutionAuthorization: 'ContractExecutionAuthorization',
};
